module.exports = __webpack_public_path__ + "img/ancient_of_slumber_small.bdb67c33.png";